import React, { useId } from "react";

/** Ссылка на документ в новой вкладке с подсказкой по наведению и фокусу. */
function LegalLink({ href, tip, className = "", children }) {
  const tipId = useId();
  return (
    <span className="legal-tip">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        aria-describedby={tipId}
        onClick={(event) => event.stopPropagation()}
      >
        {children}
      </a>
      <span id={tipId} role="tooltip" className="legal-tip-bubble">
        {tip}
      </span>
    </span>
  );
}

export default LegalLink;
